module.exports = __webpack_public_path__ + "static/media/VOE.1b2c73b2.png";